import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import QuoteCard from "./QuoteCard";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 4,
    partialVisibilityGutter: 40,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    partialVisibilityGutter: 40,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    partialVisibilityGutter: 30,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    partialVisibilityGutter: 30,
  },
};

export default function QuoteSection({...props}) {
  return (
    <section className="pt-20 pb-20" {...props}>
      <Carousel
        responsive={responsive}
        partialVisible
        infinite={true}
        arrows={false}
      >
        <QuoteCard
          body="Wei Juin was an invaluable resource in assisting us with some of our engineering projects."
          name="Kian Peen"
          standing="Founder, Embodied Sensing"
        />
        <QuoteCard
          body="The platform was built based on our requirements and the team delivered on what we wanted in terms of features and design."
          name="Edmund"
          standing="Business Strategy Manager, Air Group"
        />
        <QuoteCard
          body="It was a great working relationship and I was very impressed with the finished product."
          name="Olivia"
          standing="Facilities Coordinator, Facebook"
        />
      </Carousel>
    </section>
  );
}
